import { SpecificBooking } from "../../types/responseTypes";

async function getSpecificBooking(
  bookingId: string,
): Promise<SpecificBooking | null> {
  try {
    const url = `https://ruuf-backend.online/booking/get-specific-booking/${bookingId}`;
    const timeout = new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    if (response.status === 200) {
      console.log("Specific booking fetched successfully");
      const specificBooking: SpecificBooking = await response.json();
      return specificBooking;
    } else if (response.status === 502) {
      console.error("Invalid cookie: Error fetching user bookings");
      return null;
    } else {
      throw new Error("Could not fetch specific booking");
    }
  } catch (error) {
    console.error("Error fetching specific booking:", error);
    return null;
  }
}

export default getSpecificBooking;
